import { t } from 'ttag';

const RMA_STATUSES = {
  PENDING: t`Pending`,
  APPROVED: t`Approved`,
  REJECTED: t`Canceled`,
};

export { RMA_STATUSES };
